/**
 * @param {{ data: object, updateData: function }} ctx
 */
export function createUpdateGuardianAt({ data, updateData }) {
  return (index, patch, guardians) => {
    const updated = [...guardians];
    updated[index] = { ...updated[index], ...patch };
    updateData({ ...data, guardians: updated });
  };
}
